import ReportsContent from "./ReportsContent/ReportsContent"
import classes from './Reports.module.scss'

const ReportsWells = () => {

    return (
        <div className={classes.reportContainer}>
                <ReportsContent />
        </div>
    )
}

export default ReportsWells